export const ICookieRepositoryType = Symbol('ICookieRepository');
